module.exports = __webpack_public_path__ + "img/house-3.3318cca7.jpg";